export const UI_BUILD_VERSION = '2.3.0';
